import { deref } from "kanopi-components/utils/primitives";

export function replaceIdsWithStoragePaths(
  valuesById: object = {},
  questions: TQuestion[] = []
) {
  const valuesByStoragePath = {};
  Object.keys(valuesById).forEach((id) => {
    const storagePathForId =
      questions.find(({ id: questionId }) => id === questionId).storagePath || id;
    valuesByStoragePath[storagePathForId] = deref(valuesById, id);
  });
  return valuesByStoragePath;
}

export function getProductsFromRiskData(riskData: TRiskData) {
  const products = deref(riskData, "products", {});
  return Object.keys(products).filter(
    (productKey: string) => !!products[productKey]?.enabled
  );
}

export function getEnabledCovers(globalQuotingData: {
  covers: object[];
  riskProfile: { riskData: TRiskData };
}) {
  const allCovers = deref(globalQuotingData, "riskProfile.riskData.covers", {});
  const enabledCovers = Object.keys(allCovers).filter(
    (coverKey) => !!allCovers[coverKey].enabled
  );
  return globalQuotingData?.covers
    ?.filter((cover) => enabledCovers.includes(cover.key))
    .map((cover) => cover.title);
}

export function getRiskProfileId(globalQuotingData: { riskProfile?: { id?: string } }) {
  return globalQuotingData?.riskProfile?.id;
}

/**
 * Combines cover information with risk data pertaining to that cover
 */
export function getCoverInformation(cover: TCoverSection, riskData: TRiskData) {
  let coverRiskData = {};
  if (cover?.key) {
    coverRiskData = deref(riskData, `covers.${cover.key}`, {});
  }
  return {
    name: cover?.key,
    title: cover?.title,
    id: cover?.id,
    ...coverRiskData,
  };
}
